var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.serkan))]),_vm._l((_vm.veriler),function(col){return _c('div',{key:col.stokId},[_vm._v(_vm._s(col.adSoyad))])}),_c('button',{on:{"click":function($event){return _vm.kullanciVerileri()}}},[_vm._v("veri getir")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }